"use client";
import React from "react";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import Select from "../primitives/select";
import { BettorBadgeModel } from "common";
import Card from "../primitives/card";
import Badge from "./badge";
import NotFound from "../primitives/not-found";

export default function BadgeContainer({
  badges,
}: {
  badges: BettorBadgeModel[];
}) {
  let containerHeight = "h-full";
  if (badges.length > 8) {
    containerHeight = "h-[18rem]";
  } else if (badges.length > 4) {
    containerHeight = "h-[12rem]";
  } else {
    containerHeight = "h-[6rem]";
  }
  return (
    <Card
      header={{
        title: "Awards",
        action: (
            <></>
        //   <Select
        //     neutral
        //     label="date"
        //     defaultValue="2022-2023"
        //     options={[{ value: "2022-2023", label: "2022-2023" }]}
        //   />
        ),
      }}
    >
      <ScrollArea.Root className={`w-full`}>
        <ScrollArea.Viewport className={`w-full ${containerHeight}`}>
          <div className="flex items-center flex-wrap gap-8 mt-4">
            {badges.length > 0 ? (
              <>
                {badges.map((badge, i) => (
                  <>
                    <Badge
                      key={`${badge.id}-${badge.season}`}
                      rank={badge.rank}
                      team={badge}
                      units={badge.totalUnits}
                      year={badge.season}
                    />
                    
                  </>
                ))}
              </>
            ) : (
              <NotFound
                label="No badges yet."
                caption="Ranking in the top 25 pickers for a team will get you one."
              />
            )}
          </div>
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar
          className="flex select-none touch-none p-0.5 bg-light transition-colors duration-[160ms] ease-out hover:bg-blackA5 data-[orientation=vertical]:w-2.5 data-[orientation=horizontal]:flex-col data-[orientation=horizontal]:h-2.5"
          orientation="vertical"
        >
          <ScrollArea.Thumb className="flex-1 bg-secondary rounded-[10px] relative before:content-[''] before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full before:min-w-[44px] before:min-h-[44px]" />
        </ScrollArea.Scrollbar>
      </ScrollArea.Root>
    </Card>
  );
}
